import { ReactNode } from 'react';

import classNames from 'classnames';

import { comboboxStyles } from '../combobox.styles';
import { useComboboxContext } from '../ComboboxContext';

export interface ComboboxSelectedOptionProps {
  className?: string;
  children?: ReactNode;
}

export const ComboboxSelectedOption = ({ className, children }: ComboboxSelectedOptionProps) => {
  const { classNames: contextClassNames } = useComboboxContext();
  const styles = comboboxStyles();

  return (
    <span
      className={classNames(
        styles.selectedOption(),
        contextClassNames?.selectedOption,
        className
      )}
    >
      {children}
    </span>
  );
};
